import lazy from 'utils/lazy';

export const MobileApp = lazy(() => import('./MobileApp'));
